"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _VideoChatContext = require("./VideoChatContext");
var _utils = require("../../utils");
var _excluded = ["className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
/**
 * This component should be used as a frame-placeholder for 1 to 1 video call frame.
 * Put it on pages where video frame should take a half or another part of screen.
 * Please pay attention that only one instance of the anchor should be mounted at a time.
 */
var VideoAnchor = function VideoAnchor(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useVideoChat = (0, _VideoChatContext.useVideoChat)(),
    setAnchor = _useVideoChat.setAnchor;
  var ref = (0, _react.useRef)(null);
  var hasRefAttached = !!ref.current;
  (0, _react.useEffect)(function () {
    setAnchor(ref.current);
    return function () {
      setAnchor(function (oldAnchor) {
        if (oldAnchor === ref.current) {
          return null;
        }
        return ref.current;
      });
    };
  }, [ref.current]);
  (0, _react.useEffect)(function () {
    var eventData = {
      target: ref.current
    };
    window.dispatchEvent(new Event(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_MOUNT, eventData));
    var interval = setInterval(function () {
      window.dispatchEvent(new Event(_utils.VIDEO_CHAT_EVENTS.VIDEO_INTERVAL_UPDATE));
    }, 1000);
    return function () {
      window.dispatchEvent(new Event(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_UNMOUNT, eventData));
      clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('--tag-video-anchor bg-black p-[16px] text-center w-full h-full flex justify-center items-center', className)
  }, otherProps, {
    ref: ref
  }), !hasRefAttached && /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true,
    size: "large"
  }));
};
var _default = VideoAnchor;
exports.default = _default;